import { MessageCircleIcon } from 'lucide-react';
import { founder, salon } from '../../data/content';
import { useSite } from '../../contexts/SiteContext';
import { shopLabels } from '../../data/shopLabels';

/** Menselijk moment midden in het productraster — zoals een verkoopster die even meekijkt. */
export function AdviceTile() {
  const {
    policy
  } = useSite();
  return <aside className="flex h-full flex-col bg-clay p-5 text-shell sm:p-7" aria-label={`Advies van ${founder.firstName}`} data-id="element-6768" data-mp="2c4z4krrsv3rb">
      {/* Decoratief: haar naam staat op de knop. */}
      <img src={founder.portrait} alt="" loading="lazy" className="h-14 w-14 rounded-full object-cover" data-id="element-6769" data-mp="34t4m75nk4cmx" />
      <p className="mt-6 font-display text-[1.35rem] font-light leading-snug sm:text-2xl" data-id="element-6770" data-mp="2zziiw43a9l3s">Twijfel je tussen twee producten?</p>
      {/* Reactietijd uit de instellingen, zodat hij klopt met de rest van de site ("binnen 24 uur"). */}
      {/* Op klei altijd vol shell (5,6:1); doorschijnend wit haalt AA niet. */}
      <p className="mt-3 text-[14px] leading-relaxed text-shell" data-id="element-6771" data-mp="3npcsmcsb2tjt">
        Stuur me een foto van je huid. Ik antwoord persoonlijk binnen {policy.responseHours} uur, ook als je niets bestelt.
      </p>
      <div className="mt-auto pt-6" data-id="element-6772" data-mp="11cztxl0keurh">
        <a href={salon.whatsapp} target="_blank" rel="noreferrer" className="inline-flex min-h-[44px] w-full items-center justify-center gap-2 rounded-full bg-shell px-5 py-3 text-[14px] text-ink transition-colors duration-150 ease-soft hover:bg-blush" data-id="element-6773" data-mp="mp6dxz7khq8d">
          <MessageCircleIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-6774" data-mp="hqbi9woi476u" />
          App {founder.firstName}
          <span className="sr-only" data-id="element-6775" data-mp="3r2ddt5qwzi6">{shopLabels.viaWhatsApp}</span>
        </a>
      </div>
    </aside>;
}